import fetchGraphQL from './api';

export type ExperienceEntry = {
    dateRange: string;
    position: string;
    company: string;
    description: string;
    logo?: {
        title: string;
        url: string;
    };
    orderBy: number;
};

const query = `query {
    experienceCollection {
        items {
            dateRange
            position
            company
            description
            logo {
                title
                url
            }
            orderBy
        }
    }
}`;

export const getExperiences = async (): Promise<ExperienceEntry[]> => {
    const response = await fetchGraphQL<{ experienceCollection: { items: ExperienceEntry[] } | null }>(query);

    if (!response || !response.data) {
        throw new Error('Failed to get content response - experienceCollection');
    }

    const { experienceCollection } = response.data;
    if (!experienceCollection) {
        throw new Error('Failed to get experienceCollection - no experienceCollection');
    }

    return experienceCollection.items.map((c: ExperienceEntry) => ({
        dateRange: c.dateRange,
        position: c.position,
        company: c.company,
        description: c.description,
        logo: {
            url: c.logo?.url || '',
            title: c.logo?.title || '',
        },
        orderBy: c.orderBy,
    }));
};
